/**
 * UnderReviewBadge — small pill shown next to a topic title (or reply) when
 * the AI Ambassador has flagged its contents as misleading / unverified.
 * Every logged-in user sees the badge (user-selected: public "Under Review").
 */
import React from 'react';
import { ShieldAlert } from 'lucide-react';

const LABELS = {
  misleading: 'Under Review · Misleading',
  partially_accurate: 'Under Review · Needs Context',
  unverified: 'Under Review · Unverified',
};

const UnderReviewBadge = ({ flag, size = 'sm' }) => {
  if (!flag) return null;
  const label = LABELS[flag.verdict] || 'Under Review';
  const cls = size === 'lg' ? 'text-xs px-2 py-1' : 'text-[10px] px-1.5 py-0.5';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-widest bg-rose-500/15 text-rose-700 border border-rose-500/30 ${cls}`}
      title={flag.reason || label}
      data-testid={`under-review-${flag.target_type}-${flag.target_id}`}
    >
      <ShieldAlert className={size === 'lg' ? 'w-3.5 h-3.5' : 'w-2.5 h-2.5'} />
      {label}
    </span>
  );
};

export default UnderReviewBadge;
